/**
 * Notification specific methods that can be invoked by clients.
 *
 * @see mobiz-backend:Mobiz.Web.Core.Hubs.Notification.NotificationsHub
 */
export enum PulseNotificationHubMethod {
  ReceiveNotification = 'ReceiveNotification',
  Subscribe = 'Subscribe',
  Unsubscribe = 'Unsubscribe',
}
